import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RetestService } from 'app/services/retest-service';
import { ToastrService } from 'ngx-toastr';
import { DialogEditRetestsComponent } from '../edit/retests-edit-dialog';
import { RetestSearch } from 'app/models/retest/retest-search';
import { EditSampleComponent } from '../../well/samples/edit/edit-samples.component';
import { DialogEditVoucherComponent } from 'app/components/vouchers/edit/voucher-edit-dialog';
import { DialogEditHouseholdComponent } from 'app/components/households/edit/household-edit-dialog';
import { SharedService } from '@shared/services/shared.service';
import { DialogBulkOperationRetestsComponent } from './bulk-operation/retests-bulk-dialog';
import { RetestBulkOperation } from 'app/models/retest/retest';

@Component({
  selector: 'app-retests',
  templateUrl: './retests-search.component.html',
  styleUrls: ['./retests-search.component.scss']
})
export class RetestsSearchComponent implements OnInit {
  pageSize = 20;
  processing = false;
  showResults = false;
  selectAll = false;

  bulkOperationObj: RetestBulkOperation = {
    ids: [],
    operation: '',
    status: '',
    year: 0,
    quarter: 0,
    tier: 0,
    dueBy: ''
  };

  displayedColumns: string[] = ['select', 'id', 'wellId', 'orgininalSampleId', 'retestSampleId', 'voucherIdentifier', 'voucherStatus',/*'householdId',*/ 'retestYear', 'retestQuarter', 'tier', 'dueBy', 'isComplete', 'completedDate', 'highestNitrate','actions'];
  dataSource = new MatTableDataSource<RetestSearch>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog, public sharedService: SharedService,
    public retestService: RetestService, private toastr: ToastrService) {
    // constructor
  }

  ngOnInit(): void {
    if (this.searchResultsCount > 0) {
      this.onSubmit();
    }
  }

  updateAll() {
    this.dataSource.data.forEach(row => {
      row.isSelected = !this.selectAll;
    });
  }

  bulkOperation() {
    if(this.dataSource.data.filter(x => x.isSelected).length == 0){
      this.toastr.error('No records selected');
      return;
    }
    this.sharedService.openConfirm("Are you sure you want to perform a bulk operation on the selected retests?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) { 
        this.bulkOperationObj.ids = this.dataSource.data.filter(x => x.isSelected).map(x => x.id);
        this.bulkOperationObj.status = this.retestService.searchForm.value.isComplete;
    
        if(this.retestService.searchForm.value.retestYear != '' 
          && this.retestService.searchForm.value.retestYear != null){
          this.bulkOperationObj.year = +this.retestService.searchForm.value.retestYear;
        }
    
        if(this.retestService.searchForm.value.retestQuarter != '' 
          && this.retestService.searchForm.value.retestQuarter != null){
            this.bulkOperationObj.quarter = +this.retestService.searchForm.value.retestQuarter;
        }
    
        if(this.retestService.searchForm.value.tier != '' 
          && this.retestService.searchForm.value.tier != null){
            this.bulkOperationObj.tier = +this.retestService.searchForm.value.tier;
        }
        const dialogRef = this.dialog.open(DialogBulkOperationRetestsComponent, {
          width: '90%',
          data: this.bulkOperationObj
          });
          dialogRef.afterClosed().subscribe(result => {
              this.onSubmit();
          }
        );
      }
    });
  }

  deleteRetest(id: number) {
    this.sharedService.openConfirm("Are you sure you want to remove this scheduled retest?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.processing = true; this.retestService.deleteRetest(id).subscribe(
          result => {
            this.toastr.success("Retest deleted");
            this.onSubmit();
          },
          error => {
            this.toastr.error("Error deleting retest : " + error.message, "Error deleting retest  ");
            this.processing = false;
          },
          () => {
          }
        );
      }
    });
  }

  editRetest(id: number) {
    const dialogRef = this.dialog.open(DialogEditRetestsComponent, {
      width: '90%',
      data: id
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "Cancel") {
        this.onSubmit();
      }
    });
  }

  editSample(sampleId: number) {
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "Cancel") {
        this.onSubmit();
      }
    });
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }

  editHousehold(householdId: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: householdId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }

  onSubmit() {
    this.selectAll = false;
    this.setFormFields();
    this.processing = true;
    this.showResults = false;
    this.retestService.search(this.retestService.retestSearch).subscribe(
      result => {
        this.processing = false;
        this.showResults = true;
        this.retestService.searchResults = result;
        this.retestService.searchResultsCount = this.retestService.searchResults.length;
      },
      error => {
        this.processing = false;
        this.showResults = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<RetestSearch>(this.retestService.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  reset() {
    this.retestService.searchForm.reset({
      id: null,
      sampleId: null,
      voucherIdentifier: null,
      householdId: null,
      retestYear: null,
      retestQuarter: null,
      tier: null,
      isComplete: null,
      mismatchedTier: false
    });
  }

  setFormFields() {
    this.retestService.retestSearch.id = this.retestService.searchForm.value.id ?? 0;
    this.retestService.retestSearch.wellId = 0;
    this.retestService.retestSearch.orgininalSampleId = this.retestService.searchForm.value.sampleId ?? 0;
    this.retestService.retestSearch.retestSampleId = this.retestService.searchForm.value.sampleId ?? 0;
    this.retestService.retestSearch.voucherId = 0;
    this.retestService.retestSearch.voucherIdentifier = this.retestService.searchForm.value.voucherIdentifier ?? '';
    this.retestService.retestSearch.householdId = this.retestService.searchForm.value.householdId ?? 0;
    this.retestService.retestSearch.isComplete = this.retestService.searchForm.value.isComplete;
    this.retestService.retestSearch.wellCounty = this.retestService.searchForm.value.wellCounty ?? '';
    this.retestService.retestSearch.mismatchedTier = this.retestService.searchForm.value.mismatchedTier ?? false;

    if(this.retestService.searchForm.value.retestYear != '' 
      && this.retestService.searchForm.value.retestYear != null){
      this.retestService.retestSearch.retestYear = this.retestService.searchForm.value.retestYear;
    }
    else {
      this.retestService.retestSearch.retestYear = '0';
    }

    if(this.retestService.searchForm.value.retestQuarter != '' 
      && this.retestService.searchForm.value.retestQuarter != null){
      this.retestService.retestSearch.retestQuarter = this.retestService.searchForm.value.retestQuarter;
    }
    else {
      this.retestService.retestSearch.retestQuarter = '0';
    }

    if(this.retestService.searchForm.value.tier != '' 
      && this.retestService.searchForm.value.tier != null){
      this.retestService.retestSearch.tier = this.retestService.searchForm.value.tier;
    }
    else {
      this.retestService.retestSearch.tier = '0';
    }
  }

  searchResults(): RetestSearch[] {
    return this.retestService.searchResults;
  }

  searchResultsCount = this.retestService.searchResultsCount;
}